import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["isActive"];
// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/icon-navigation-template-activatable/src/index.tsx
import React from 'react';
import baseIcon, { navigationActivatableDefaultStyleSheetGetter, defaultNavigationIconGroupProps, defaultNavigationIconShapeSize } from '@bubble-ui/temp-icon-base';
import useDeprecationWarning from '@bubble-ui/hook-use-deprecation-warning';
var NavigationIconProfileAlternativePath = 'M15,2.99999995 C21.627417,2.99999995 27,8.37258298 27,15 C27,21.627417 21.627417,27 15,27 C8.37258298,27 2.99999995,21.627417 2.99999995,15 C2.99999995,8.37258298 8.37258298,2.99999995 15,2.99999995 Z M11.6282076,18.7974196 C11.4208528,18.7824946 11.2195411,18.8604842 11.0581064,19.0314587 L10.9808688,19.1246951 L8.32393162,22.445263 C10.0942407,24.0337387 12.4342791,25 15,25 C17.570571,25 19.9146055,24.030082 21.6861018,22.4362479 L19.1394023,19.1492234 C18.9653191,18.9452763 18.7178223,18.8210232 18.427136,18.801756 L18.3,18.8 L11.6282076,18.7974196 Z M15,4.99999996 C9.47715248,4.99999996 4.99999996,9.47715248 4.99999996,15 C4.99999996,17.2283929 5.72888546,19.2865454 6.96125083,20.949052 L9.38943946,17.9143451 C9.90080002,17.2066097 10.7200842,16.7930038 11.5273216,16.7935085 L11.7,16.8 L11.7512386,16.8008529 C10.6793597,15.8838019 9.99999998,14.5212374 9.99999998,13 C9.99999998,10.2385762 12.2385762,7.99999997 15,7.99999997 C17.7614238,7.99999997 20,10.2385762 20,13 C20,14.5212374 19.3206403,15.8838019 18.2487613,16.8008529 L18.2605978,16.8007766 C19.1136068,16.76714 19.9372075,17.0984062 20.5522628,17.7351034 L20.6904151,17.8874283 L23.0505103,20.933153 C24.2757506,19.2734318 25,17.2212947 25,15 C25,9.47715248 20.5228475,4.99999996 15,4.99999996 Z M15,9.99999998 C13.3431457,9.99999998 12,11.3431457 12,13 C12,14.6568542 13.3431457,16 15,16 C16.6568543,16 18,14.6568542 18,13 C18,11.3431457 16.6568543,9.99999998 15,9.99999998 Z';
var NavigationIconProfileAlternativeActivePath = 'M15,2.99999995 C21.627417,2.99999995 27,8.37258298 27,15 C27,21.627417 21.627417,27 15,27 C8.37258298,27 2.99999995,21.627417 2.99999995,15 C2.99999995,8.37258298 8.37258298,2.99999995 15,2.99999995 Z M18.6,17.8 C17.5549132,18.5664269 16.2959256,18.9860894 15,19 C13.7040744,18.9860894 12.4450868,18.5664269 11.4,17.8 C10.9259783,17.8734884 10.4972958,18.1235531 10.2,18.5 L7.59999997,21.7 C9.47871522,23.8139739 12.1718457,25.0235268 15,25.0235268 C17.8281543,25.0235268 20.5212848,23.8139739 22.4,21.7 L19.8,18.5 C19.5027042,18.1235531 19.0740217,17.8734884 18.6,17.8 Z M15,8.99999998 C12.790861,8.99999998 11,10.790861 11,13 C11,15.209139 12.790861,17 15,17 C17.209139,17 19,15.209139 19,13 C19,10.790861 17.209139,8.99999998 15,8.99999998 Z';
var NavigationIcon = baseIcon('NavigationIconProfileAlternative', {
  getPath: _ref => {
    var {
      isActive
    } = _ref;
    return isActive ? NavigationIconProfileAlternativeActivePath : NavigationIconProfileAlternativePath;
  },
  styleSheetPropsGetter: (_ref2, designVersion) => {
    var {
      isActive,
      color,
      colorToken,
      colorTokenArgs
    } = _ref2;
    return {
      isActive,
      color,
      designVersion,
      colorToken,
      colorTokenArgs
    };
  },
  defaultStyleSheetGetter: navigationActivatableDefaultStyleSheetGetter,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  restOfPropsSanitizer: _ref3 => {
    var {
        isActive
      } = _ref3,
      restOfProps = _objectWithoutProperties(_ref3, _excluded);
    return restOfProps;
  },
  groupProps: defaultNavigationIconGroupProps,
  shapeSize: defaultNavigationIconShapeSize
});
var NavigationIconProfileAlternative = props => {
  useDeprecationWarning({
    componentName: 'NavigationIconProfileAlternative',
    removalDate: 'v6.0.0'
  });
  return /*#__PURE__*/React.createElement(NavigationIcon, props);
};
NavigationIconProfileAlternative.displayName = 'NavigationIconProfileAlternative';
export default NavigationIconProfileAlternative;
//# sourceMappingURL=index.js.map